<script>
	// NPM Modules
	import { tick } from 'svelte';
	// Components
	import Icon from '@/Components/Icon.svelte';
	// Partials
	import ManageDerivedMarketTemplate from '@/Partials/Sport/Manage/DerivedMarkets/_ManageDerivedMarketTemplate.svelte';
	// Stores
	import DerivedMarketTemplateStore from '@/Stores/Sport/DerivedMarketTemplateStore.js';

	export let sport;

	let showDerivedMarket = false;
	let selectedDerivedMarketTemplate = undefined;

	$: derivedMarkets = $DerivedMarketTemplateStore && $DerivedMarketTemplateStore.all();

	DerivedMarketTemplateStore.getDerivedMarketTemplatesForSport(sport.id);

	async function openDerivedMarketTemplateManage(derivedMarketTemplateId) {
		selectedDerivedMarketTemplate = derivedMarketTemplateId;
		showDerivedMarket = true;
		await tick();
		window.scrollTo(0, 0);
	}
</script>

{#if showDerivedMarket}
	<ManageDerivedMarketTemplate
		bind:open={showDerivedMarket}
		bind:sport
		bind:derivedMarketTemplateId={selectedDerivedMarketTemplate}
	/>
{/if}

<div class="flex items-center justify-end w-full">
	<button on:click={() => openDerivedMarketTemplateManage()} class="btn btn-primary"
		>Create new derived market template</button
	>
</div>

<table class="w-full whitespace-nowrap mt-3">
	<thead>
		<tr class="text-xs text-left text-gray-500 uppercase">
			<th class="px-6 pt-3 pb-2 font-medium">Derived Market Template Name</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Parent Market</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Sport</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-right" />
		</tr>
	</thead>
	<tbody class="bg-white">
		{#each derivedMarkets as derivedMarket (derivedMarket.id)}
			{#if derivedMarket.id !== 'create'}
				<tr
					on:click={() => {
						selectedDerivedMarketTemplate = derivedMarket;
						openDerivedMarketTemplateManage(derivedMarket.id);
					}}
					class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100"
				>
					<td class="p-4 px-6 border-t">
						<div class="flex items-center">
							<div class="mr-2 font-semibold">{derivedMarket?.name}</div>
						</div>
					</td>
					<td class="w-px px-6 border-t">{derivedMarket?.parent_market?.name}</td>
					<td class="w-px px-6 border-t">
						<div class="px-2 py-1 bg-green-500 rounded-md text-light">
							{derivedMarket?.sport?.name}
						</div>
					</td>
					<td class="w-px px-6 border-t" style="max-width: 50%;">
						<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
					</td>
				</tr>
			{/if}
		{:else}
			<tr>
				<td class="px-6 py-4 text-center border-t" colspan="9">
					No derived markets found for {sport.name}.
				</td>
			</tr>
		{/each}
	</tbody>
</table>
